import React, { useState, useMemo } from 'react'
import SearchPage from 'containers/SearchPage'
import { Chip, Button, Person } from '@arnsbogroup/react-voicearchive'
import { FormattedMessage, FormattedDate, useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import messages from './messages'
import useApi from 'hooks/useApi'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

const AnnouncementsPage = () => {
  const { formatMessage } = useIntl()
  const [tags, setTags] = useState([])

  const [data] = useApi('/rest/v2/announcement')

  const announcements = useMemo(() => tags.length
    ? data.filter((announcements) => announcements.tags.some((tag) => tags.includes(tag)))
    : data
  , [tags, data])

  return (
    <div className="w-full h-full py-3 px-4 lg:py-5 lg:px-6 space-y-6">
      <div className="pb-5 border-b border-gray-200">
        <h3 className="text-lg leading-6 font-medium text-gray-900 space-x-2">
          <FormattedMessage {...messages.title} />
        </h3>
        <p className="mt-2 max-w-4xl text-sm text-gray-500">
          <FormattedMessage {...messages.subtitle} />
        </p>
      </div>


      <div className="max-w-5xl divide-y divide-gray-200 m-auto">
        { announcements?.map((announcement) => (
          <article id={announcement.title} key={announcement.title} className="flex flex-col sm:flex-row gap-6 py-6">
            <div className="w-full sm:w-1/3 flex flex-col space-y-3">
              { !announcement.acked &&
                <div>
                  <Chip state="success">
                    <FormattedMessage {...messages.new} />
                  </Chip>
                </div>
              }

              <h3 className="text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                <a href={`#${announcement.title}`}>
                  { announcement.title }
                </a>
              </h3>

              <time dateTime={announcement.created_at} className="text-gray-500 text-sm">
                <FormattedDate value={new Date(announcement.created_at)} />
              </time>

              <div className="flex space-x-2">
                { announcement.tags?.map((tag) => (
                  <Chip
                    state={tags.includes(tag) ? 'info' : undefined}
                    onClick={() => setTags((prev) => tags.includes(tag) ? prev.filter((t) => t != tag) : [...prev, tag])}
                  >
                    { tag }
                  </Chip>
                )) }
              </div>

              { !!announcement.labs.length &&
                <div>
                  <Link to="/settings/features">
                    <Button variant="inline" icon={['fas', 'arrow-right']} iconPosition="right">
                      <FormattedMessage {...messages.featureFlagLink} />
                    </Button>
                  </Link>
                </div>
              }
            </div>

            <div className="w-full sm:w-2/3">
              <div>
                <ReactMarkdown
                  children={announcement.body}
                  rehypePlugins={[rehypeRaw]}
                  components={{
                    img: ({ node, ...props }) => <img className="border border-gray-400 shadow-sm my-8 max-w-full" {...props} />,
                    ul: ({ node, ...props }) => <ul className="list-disc" {...props } />,
                    kbd: ({ node, ...props }) => <Kbd {...props} />,
                    p: ({ node, ...props }) => <p className="mb-3" {...props} />,
                  }}
                />
              </div>

              { announcement.created_by &&
                <div className="mt-10">
                  <Person {...announcement.created_by} />
                </div>
              }
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}

export default AnnouncementsPage
